import {merge} from 'lodash';
import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {META_TAG_POINTS, NUMBER_TITLE_ID} from '@axyseo/const/analysis';

/**
 * Represents the assessment that assesses the SEO title width and gives the feedback accordingly.
 */
export default class NumberInMetaTitleAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object}  [config]        The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: NUMBER_TITLE_ID,
      ctaType: 'fix',
      status: 'good',
      docUrl:
        'https://docs.avada.io/seo-suite-help-center/seo-on-page-audit/checklist#using-number-in-title',
      priority: 'high',
      fixPosition: 'meta title',
      title: 'Number in meta title',
      content: {
        good: 'Number is used effectively in the title tag.',
        improve: '',
        bad: 'No number found in title tag. Consider adding a number to make it more engaging.'
      }
    };

    this.identifier = NUMBER_TITLE_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Runs the h1 research and based on this returns an assessment result with a score.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   * @param {Researcher}  researcher  The researcher used for calling the research.
   * @returns {AssessmentResult} The assessment result.
   */
  getResult({paper, researcher}) {
    const assessmentResult = new AssessmentResult({config: this._config});

    const calculatedResult = this.calculateResult(paper);

    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);

    return assessmentResult;
  }

  /**
   *
   * @param paper
   * @returns {{score: number, body: React.JSX.Element, status: string}}
   */
  calculateResult(paper) {
    const title = paper.getTitle();

    let status = 'bad';
    if (!/\d/.test(title)) {
      status = 'bad';
    }

    if (!title || /\d/.test(title)) {
      status = 'good';
    }

    const score = this.getScore(META_TAG_POINTS, status);

    return {
      score,
      status
    };
  }

  /**
   * Checks whether the paper has a text.
   *
   * @param {Paper}       paper       The paper to use for the assessment.
   *
   * @returns {boolean} True when there is text.
   */
  isApplicable(paper) {
    return true;
  }
}
